var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 3.5C13.9624 3.5 11.5 5.96243 11.5 9C11.5 12.0376 13.9624 14.5 17 14.5C20.0376 14.5 22.5 12.0376 22.5 9C22.5 5.96243 20.0376 3.5 17 3.5ZM8.5 9C8.5 4.30558 12.3056 0.5 17 0.5C21.6944 0.5 25.5 4.30558 25.5 9C25.5 13.6944 21.6944 17.5 17 17.5C12.3056 17.5 8.5 13.6944 8.5 9Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4919 18H25.4194C24.4274 18 23.4355 18.2457 22.5403 18.688L19.879 20.0394C18.0645 20.9485 15.9597 20.9485 14.1452 20.064L11.3629 18.688C10.4677 18.2457 9.5 18.0246 8.50806 18.0246C4.90322 18.0246 2 20.9731 2 24.6341V26.2284C2 28.468 3.48849 30.4537 5.66672 30.9745C14.1718 33.008 20.0808 32.9211 28.311 30.9675C30.4993 30.448 32 28.4573 32 26.2082V24.6341C32 20.9485 29.0726 18 25.4919 18Z",
    fill: "#FFB6BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8759 17.3432C22.9641 16.8055 24.1823 16.5 25.4194 16.5H25.4919C29.9228 16.5 33.5 20.142 33.5 24.6341V26.2082C33.5 29.1178 31.5549 31.7391 28.6574 32.4269C20.2069 34.4328 14.0596 34.5235 5.3179 32.4334C2.42901 31.7426 0.5 29.1247 0.5 26.2284V24.6341C0.5 20.1666 4.053 16.5246 8.50806 16.5246C9.72623 16.5246 10.9218 16.797 12.0273 17.3432L14.8061 18.7174C16.2032 19.3971 17.8135 19.3952 19.2037 18.7C19.2048 18.6994 19.206 18.6989 19.2071 18.6983L21.8612 17.3505L21.8759 17.3432ZM23.2117 20.0294L20.551 21.3805C18.3141 22.5012 15.7178 22.4993 13.4879 21.4123L13.4802 21.4085L10.6985 20.0328C10.6983 20.0327 10.6986 20.0329 10.6985 20.0328C10.0138 19.6946 9.27358 19.5246 8.50806 19.5246C5.75345 19.5246 3.5 21.7795 3.5 24.6341V26.2284C3.5 27.8112 4.54797 29.1647 6.01553 29.5156C14.2839 31.4926 19.9547 31.4093 27.9645 29.508C29.4437 29.1569 30.5 27.7968 30.5 26.2082V24.6341C30.5 21.755 28.2224 19.5 25.4919 19.5H25.4194C24.6749 19.5 23.9118 19.6847 23.2117 20.0294Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/ic_user.4dfee7dc3b242828402dde1594280966.svg";
export { ForwardRef as ReactComponent };